import { serializeSchema } from './business';

// A single, StrictMode-safe owner for head tags. Adopt prerendered nodes in
// place, discard duplicates, and never let a late cleanup erase a newer page.
export const setHeadTag = (selector, tag, attributes, text) => {
  const nodes = [...document.head.querySelectorAll(selector)];
  const node = nodes.shift() || document.createElement(tag);
  nodes.forEach((duplicate) => duplicate.remove());
  node.removeAttribute('data-rh');
  Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
  if (text !== undefined) node.textContent = text;
  if (!node.isConnected) document.head.appendChild(node);
  return node;
};

export const setSchema = (id, value, owner) => {
  const selector = `script[id="${id}"]`;
  if (!value) {
    document.head.querySelectorAll(selector).forEach((node) => node.remove());
    return () => {};
  }
  const node = setHeadTag(selector, 'script', { id, type: 'application/ld+json' }, serializeSchema(value));
  node.seoOwner = owner;
  return () => { if (node.seoOwner === owner) node.remove(); };
};